import api from '../utils/api';
import { buildUploadUrl } from '../config/runtimeConfig';

// Get company settings
export const getCompanySettings = async () => {
  return await api.get('/api/settings/company');
};

// Update company settings
export const updateCompanySettings = async (settingsData) => {
  return await api.put('/api/settings/company', settingsData);
};

export const updateSignatureLayout = async (documentType, layout) => {
  return await api.put('/api/settings/company/signature-layout', {
    document_type: documentType,
    layout,
  });
};

// Upload company logo
export const uploadCompanyLogo = async (logoFile) => {
  const formData = new FormData();
  formData.append('logo', logoFile);
  
  return await api.post('/api/settings/company/logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Delete company logo
export const deleteCompanyLogo = async () => {
  return await api.delete('/api/settings/company/logo');
};

// Helper function to get full logo URL
export const getLogoUrl = (logoPath) => {
  if (!logoPath) return null;
  return buildUploadUrl(logoPath);
};

// Upload company signature
export const uploadCompanySignature = async (signatureFile) => {
  const formData = new FormData();
  formData.append('signature', signatureFile);
  
  return await api.post('/api/settings/company/signature', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Delete company signature
export const deleteCompanySignature = async () => {
  return await api.delete('/api/settings/company/signature');
};

// Helper function to get full signature URL
export const getSignatureUrl = (signaturePath) => {
  if (!signaturePath) return null;
  return buildUploadUrl(signaturePath);
};

// Upload company stamp
export const uploadCompanyStamp = async (stampFile) => {
  const formData = new FormData();
  formData.append('stamp', stampFile);
  
  return await api.post('/api/settings/company/stamp', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Delete company stamp
export const deleteCompanyStamp = async () => {
  return await api.delete('/api/settings/company/stamp');
};

// Helper function to get full stamp URL
export const getStampUrl = (stampPath) => {
  if (!stampPath) return null;
  return buildUploadUrl(stampPath);
};
